const CheckValidStatusRest = (response, store) => {
    if(!response || [401, 403].includes(response.status || response.code)) {
        store.forceLogout(true);
        throw new Error(`response status ${response.status || response.code}, logging out`);
    }
    return response.json();    
}
export default CheckValidStatusRest;